import React from 'react';
import './ProjectsHero.scss';
import {ReactComponent as ArrowLeft} from '../../../../assets/icons/arrowLeft.svg';
import IconButtonMUI from '../../../../shared/IconButtonMUI';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

const ProjectsHero = ({heading, subHeading = '', showArrow = false, buttonHandler, buttons}) => {
  const {singleProject} = useSelector((state) => state.projects);
  const {t} = useTranslation();
  return (
    <>
      <div className='projects__header'>{singleProject.address}</div>
      <div className={'projects__hero'}>
        <div className='projects__hero-left'>
          {showArrow && (
            <div className='projects__hero-arrow' onClick={buttonHandler}>
              <IconButtonMUI color='primary' title={t('all.back')}>
                <ArrowLeft />
              </IconButtonMUI>
            </div>
          )}

          <div className='projects__hero-data'>
            {subHeading && <p>{subHeading}</p>}
            <h3>{heading}</h3>
          </div>
        </div>
        <div className='projects__hero-icons'>{buttons ? buttons : null}</div>
      </div>
    </>
  );
};

export default ProjectsHero;
